export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-mixed-black/d21b5875d042081b9f1e0968ad570103.webp";